import { BrandListConstants } from '../constants/';

export function brandListReducer(state = {}, action) {
    switch (action.type) {
        case BrandListConstants.GETALL_BRANDS_REQUEST:
            return {
                loading: true
            };
        case BrandListConstants.GETALL_BRANDS_SUCCESS:
            return {
                items: action.brandList,
                loading:false
            };
        case BrandListConstants.GETALL_BRANDS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}